import React, { useCallback } from 'react';
import { Drawer, Container, Grid, AppBar, Tabs, Tab } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { IoIosCloseCircleOutline } from 'react-icons/io';

import Detalhes from '../NewProdutoPizza/tabs/Detalhes';
import Tamanhos from '../NewProdutoPizza/tabs/Tamanhos';
import Complementos from '../NewProdutoPizza/tabs/Complementos';
import Disponibilidade from '../NewProdutoPizza/tabs/Disponibilidade';

import { useProdutoPizza } from '../../../../../../hooks/produtoPizza';
import { useToast } from '../../../../../../hooks/toast';

import api from '../../../../../../services/api';

import {
  CloseButton,
  DrawerContainer,
} from '../../../../../../components/Drawer/styles';

import { MenuOptionButton } from '../../../styles';
import { DrawerTitle } from '../../drawer_styles';

import TabPanel from '../../../../../Configuracoes/TabBar/TabPanel';

interface a11yPropsReturnType {
  id: string;
  'aria-controls': string;
}

function a11yProps(index: number): a11yPropsReturnType {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  noShadow: {
    boxShadow: 'none',
  },
  tabBorder: {
    borderBottom: '1px solid #e0e0e0',
  },
  noPaddingTop: {
    paddingTop: '0 !important',
  },
}));

interface EditProdutoPizza {
  produto: any;
}

const EditProdutoPizza: React.FC<EditProdutoPizza> = ({ produto }) => {
  const classes = useStyles();

  const { addToast } = useToast();

  const {
    produtoId,
    drawerIsOpen,
    currentTabIndex,
    tamanhosIsEnabled,
    complementosIsEnabled,
    disponibilidadeIsEnabled,
    openDrawer,
    resetDrawer,
    changeCurrentTabIndex,
    changeProdutoPizzaData,
    enableComplementos,
    enableTamanhos,
    enableDisponibilidade,
    enableItensComplementos,
    toggleEditingProduto,
  } = useProdutoPizza();

  const handleFetchGroupDetails = useCallback(async () => {
    addToast({
      title: 'Aguarde',
      description: 'Estamos obtendo as informações do produto.',
      type: 'info',
    });

    try {
      const complementosResponse = await api.get(
        `/complemento/${produto.grupo_produto_id}`,
      );

      const complementos: any[] = [];
      const itens: any[] = [];

      await Promise.all(
        complementosResponse.data.map(
          async (complemento: any, complementoIndex: any) => {
            complementos.push({
              ...complemento,
              index: complementoIndex,
            });

            const response = await api.post(
              `/complemento/item/${complemento.id}`,
            );

            response.data.forEach((item: any) => {
              itens.push({
                ...item,
                index_complemento: complementoIndex,
              });
            });
          },
        ),
      );

      changeProdutoPizzaData({
        ...produto,
        complementos,
        itens_complemento: itens,
      });
      toggleEditingProduto(produto.id);
      enableComplementos();
      enableTamanhos();
      enableDisponibilidade();
      enableItensComplementos();
      openDrawer();
    } catch (err) {
      addToast({
        title: 'Algo deu errado',
        description: 'Ocorreu um erro ao buscar as informações do produto.',
        type: 'error',
      });
    }
  }, [
    produto,
    addToast,
    openDrawer,
    changeProdutoPizzaData,
    enableComplementos,
    enableDisponibilidade,
    enableTamanhos,
    enableItensComplementos,
    toggleEditingProduto,
  ]);

  return (
    <>
      <MenuOptionButton type="button" onClick={handleFetchGroupDetails}>
        Editar Produto
      </MenuOptionButton>

      <Drawer
        anchor="right"
        open={drawerIsOpen && produtoId === produto.id}
        onClose={resetDrawer}
      >
        <CloseButton onClick={resetDrawer} type="button">
          <IoIosCloseCircleOutline size={24} />
        </CloseButton>

        <DrawerContainer role="presentation" className={classes.noPaddingTop}>
          <Container maxWidth="lg">
            <Grid item xs={12}>
              <DrawerTitle className="titleDrawer_with_tabs">
                <h1>Editar Produto</h1>
              </DrawerTitle>
            </Grid>

            <Grid item xs={12}>
              <div className={classes.root}>
                <AppBar
                  position="static"
                  color="transparent"
                  className={classes.noShadow}
                >
                  <Tabs
                    value={currentTabIndex}
                    onChange={(event, value) => changeCurrentTabIndex(value)}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="product_tabs"
                    className={classes.tabBorder}
                  >
                    <Tab label="Detalhes" {...a11yProps(0)} />
                    <Tab
                      label="Tamanhos"
                      {...a11yProps(1)}
                      disabled={!tamanhosIsEnabled}
                    />
                    <Tab
                      label="Complementos"
                      {...a11yProps(2)}
                      disabled={!complementosIsEnabled}
                    />
                    <Tab
                      label="Disponibilidade"
                      {...a11yProps(3)}
                      disabled={!disponibilidadeIsEnabled}
                    />
                  </Tabs>
                </AppBar>

                <TabPanel value={currentTabIndex} index={0}>
                  <Detalhes />
                </TabPanel>
                <TabPanel
                  value={currentTabIndex}
                  index={1}
                  containerStyle={{ padding: 0 }}
                >
                  <Tamanhos />
                </TabPanel>
                <TabPanel value={currentTabIndex} index={2}>
                  <Complementos grupo_id={produto.grupo_id} />
                </TabPanel>
                <TabPanel value={currentTabIndex} index={3}>
                  <Disponibilidade />
                </TabPanel>
              </div>
            </Grid>
          </Container>
        </DrawerContainer>
      </Drawer>
    </>
  );
};

export default EditProdutoPizza;
